import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ExplainerDialogService } from 'app/core/explainer-dialog.service';
import { Tier } from 'app/shared/account/tier.model';
import { ExplainerContent } from 'app/shared/explainer-dialog/explainer-dialog-content';

@Component({
  selector: 'app-upgrade-tier',
  imports: [FormsModule, MatIconModule, MatTooltipModule, MatRadioModule, TranslateModule],
  templateUrl: './upgrade-tier.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upgrade-tier.component.scss',
})
export class UpgradeTierComponent {
  @Input() tier: string;
  // Stripe rejects a tier downgrade server-side (TierDowngradeNotAllowed), so only Shopify unlocks it.
  @Input() allowDowngrade = false;
  @Output() tierChange = new EventEmitter<Tier>();
  public Tier = Tier;
  public EXPLAINER_TEXTS = {
    tier: {
      description: 'billing.tier-input',
    },
  };

  constructor(public explainerDialogService: ExplainerDialogService) {}

  public get isEssentialDisabled(): boolean {
    return !this.allowDowngrade && (this.tier === Tier.Pro || this.tier === Tier.Success);
  }

  public get isProDisabled(): boolean {
    return !this.allowDowngrade && this.tier === Tier.Success;
  }

  public calculatePriceAndTrafficForTier(event) {
    this.tierChange.emit(event.value);
  }

  public openExplainerDialog(explainerContent: ExplainerContent, eventTarget): void {
    this.explainerDialogService.setContentExpainer(explainerContent);
    this.explainerDialogService.explainerBS.next({
      top: eventTarget.getBoundingClientRect().top + window.pageYOffset,
      left: eventTarget.getBoundingClientRect().left + window.pageXOffset,
      isExisted: true,
      menuIsOpen: true,
    });
  }
}
